import React, { useState, useEffect } from "react";
import { Dialog, PaperProps } from "@material-ui/core";
// import {
//   useTracking,
//   TrackingPage,
// } from "Components/Tracking/TrackingProvider";
import { useApp } from "Providers/AppProvider";

export const PRESENTAION_ELEMENT_ID = "planning-board-presentation";
export const DIALOG_ROOT_CLASS_NAME = "MuiDialog-root";

function Modal<T>(props: {
  modalController: ModalController<T>;
  // pagePath: TrackingPage;
  // previousPagePath?: TrackingPage;
  children?: JSX.Element | JSX.Element[] | null;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  isCloseDisabled?: boolean;
  fullScreen?: boolean;
  PaperProps?: Partial<PaperProps>;
}) {
  // const { trackPage } = useTracking();
  const { isStandaloneApp, mountPoint } = useApp();

  // useEffect(() => {
  //   trackPage(props.pagePath);

  //   return () => {
  //     trackPage(props.previousPagePath || TrackingPage.EXTERNAL_CHAT);
  //   };
  // }, [trackPage, props.pagePath, props.previousPagePath]);

  useEffect(() => {
    const container = isStandaloneApp ? document.body : mountPoint;

    if (container) {
      container.style.overflowY = props.modalController.isOpen
        ? "hidden"
        : "scroll";

      return () => {
        container.style.overflowY = "scroll";
      };
    }
  }, [props.modalController.isOpen, isStandaloneApp, mountPoint]);

  return (
    <Dialog
      open={
        true /* Do not use  `modalController.isOpen` to support correct tracking! */
      }
      PaperProps={props.PaperProps}
      onClose={() => props.modalController.close()}
      maxWidth={props.size}
      disableEscapeKeyDown={props.isCloseDisabled}
      disableBackdropClick={props.isCloseDisabled}
      fullScreen={props.fullScreen}
      disableEnforceFocus
      disablePortal
      disableAutoFocus
      fullWidth
    >
      {props.children}
    </Dialog>
  );
}

export default Modal;

export interface ModalController<T> {
  isOpen: boolean;
  open: (openedItem?: T, isNew?: boolean) => void | boolean;
  close: (id?: string) => void;
  item?: T;
  isNew?: boolean;
}

export function useModalController<T>(props?: {
  isDefaultOpen?: boolean;
  onClose?: (id?: string) => void;
}) {
  const [isOpen, setIsOpen] = useState(!!props?.isDefaultOpen);
  const [isNew, setIsNew] = useState(false);
  const [item, setItem] = useState<T>();

  const modalController: ModalController<T> = {
    isOpen,
    isNew,
    item,
    open: (openedItem?: T, isNew?: boolean) => {
      setItem(openedItem);
      setIsOpen(true);
      setIsNew(!!isNew);
    },
    close: (id?: string) => {
      setIsOpen(false);
      if (props?.onClose) {
        props?.onClose(id);
      }
    },
  };

  return modalController;
}
